import raw from './plan-data.json' with { type: 'json' };
import type { PlanData } from './types.ts';

/** The only source of plan content. Nothing in the app hardcodes an exercise, meal,
 *  calorie figure, rep scheme or checkpoint criterion. */
export const PLAN = raw as unknown as PlanData;
export const META = PLAN.meta;
